import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, ListItemIcon, ListItemText, InputAdornment, OutlinedInput, FormControl, InputLabel } from '@material-ui/core/';
import { useParams, Redirect } from 'react-router-dom';
import Content from '../components/Content';
import { validateVal, isEmpty } from 'utils/helpers';
import { sendGetRequest, sendPostRequest, sendPutRequest, sendDeleteRequest } from 'utils/api';
import useStyles from 'styles/forms';
import { formPropTypes, formDefaultPropValues } from 'proptypes/index';
import Blocker from 'components/Blocker';
import { ErrorAlert, SuccessAlert,WarningAlert } from 'components/Alerts';
import BasicDropDown from './forms/formElements/toolsDropdown';
import PickList from './forms/formElements/PickList';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { palette } from  '@material-ui/system'
import { useHistory } from 'react-router-dom';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ChevronRightTwoToneIcon from '@material-ui/icons/ChevronRightTwoTone';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { truncate } from 'lodash';

const options = [
	'Search',
	'Back',
  ];
  
const ITEM_HEIGHT = 48;

const table = 'employees';


const validateForm = (key, value) => {
	const errors = {};
	switch (key) {
		case 'config_name':
			errors.config_name = validateVal({
				value: value,
				maxLength: 100,
				required: true,
			});
			break;
		
		case 'config_type':
			errors.config_type = validateVal({
				value: value,
				maxLength: 50,
				required: true,
			});

			break;

		default:
			break;
	}
	return errors;
};

const validateFormValues = (values) => {
	let errors = [];
	Object.keys(values).forEach((key) => {
		errors = { ...errors, ...validateForm(key, values[key]) };
	});
	return errors;
};

const actions = {create: 'Create New Config', edit: 'Edit Config', delete: 'Delete Config', close:'Close', search:'Search'}

const data = [{}]

const ToolsForm = (props) => {

	const classes = useStyles();
	const params = useParams();
	const history = useHistory();
	const { closeModal } = props;

	const [departments, setDepartments] = useState([]);
	const [companies, setCompanies] = useState([]);

	const [inputDisabled, setInputDisabled] = useState(true);
	const [inputColor, setInputColor] = useState(null);
	const [inputMsg, setInputMsg] = useState(null)

	const [formValues, setFormValues] = useState({});
	const [formErrors, setFormErrors] = useState({});
	const [requesting, setRequesting] = useState(false);
	const [success, setSuccess] = useState(null);
	const [status, setStatus] = useState(null);
	const [action, setAction] = useState(null);

	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);

	useEffect(() => {
		
		if (parseInt(params.id)) {
			const path = `/${table}/${params.id}`;
	
			setRequesting(true);
			sendGetRequest(path).then((res) => {
				setRequesting(false);
				if (res.error) {
					setSuccess(false);
					setStatus(res.error.message);
					return;
				}
				setFormValues({...formValues, 
                    fullname: res.data[0].fullname, 
                    empId: res.data[0].empId,
                    userName: res.data[0].userName,
                    empStat: res.data[0].empStat,
                    jobTitle: res.data[0].jobTitle,
                    jobLevel: res.data[0].jobLevel,
                    company: res.data[0].company,
                    division: res.data[0].division,
                    department: res.data[0].department,
                    section: res.data[0].section,
                    gridLoc: res.data[0].gridLoc,
                    grid: res.data[0].grid,
                })
				setFormErrors(validateFormValues(res.data[0]));
			});
		}else{

			if(params.id === 'create'){
				setAction(actions.create);
				setInputDisabled(false);
				setInputMsg('Create');
				setInputColor('Primary');
				setFormValues('');
				setSuccess('');
				setStatus(''); 
			}

		}
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onSubmit = (e) => {
		e.preventDefault();
		setRequesting(true);
		
		let postData = {...formValues};
        
	    if(action === 'Create New Config'){
           postData = {...postData, id:'0'}
		  
			sendPostRequest(`/${table}`, postData).then((res) => {
			   setRequesting(false);
			   if (res.error) {
				   setSuccess(false);
				   setStatus(res.error.message);
				   return;
			   }

			   setSuccess(true);
			   setStatus('New Configuration Successfully Saved'); 
			   setFormValues('')
			});  
		}
		
		if(action === 'Edit Config'){
			postData = {...postData, id: params.id}
		  
			sendPutRequest(`/${table}`, postData).then((res) => {
			   setRequesting(false);
			   if (res.error) {
				   setSuccess(false);
				   setStatus(res.error.message);
				   return;
			   }

			   setSuccess(true);
			   setStatus('Configuration Successfully Updated'); 
			});  
		 }

		 if(action === 'Delete Config'){
			postData = {...postData, id: params.id}
		  
			sendDeleteRequest(`/${table}`, postData).then((res) => {
			   setRequesting(false);
			   if (res.error) {
				   setSuccess(false);
				   setStatus(res.error.message);
				   return;
			   }

			   setSuccess(true);
			   setStatus('Configuration Successfully Deleted'); 
			   setFormValues('')
			});  
		 }
         //setFormValues('')
	   /*if(action === actions.create){
			setFormValues({ ...formValues, idMaster: res.data[0].idMaster });
		    }
		closeModal ? closeModal(res.data[0].idMaster) : setSuccess(true);*/
			
	};    

	const handleClose = (e, p) => {
		
		switch(p){
			case 'Create':
				setAction(actions.create);
				setInputDisabled(false);
				setInputMsg('Create');
				setInputColor('Primary');
				setFormValues('');
				setSuccess('');
				setStatus(''); 
				break;
			
			case 'Edit':
				if(params.id){
					if(parseInt(params.id) > 0){
						setAction(actions.edit);
						setInputDisabled(false);
						setInputMsg('Update');
						setInputColor('primary')
						setSuccess('');
						setStatus(''); 
					}else{
						
						alert("No item to Edit.");
					}
				}else{
					
					alert("No item to Edit.");
				}
				
				break;
			
			case 'Search':
				setAction(null);
				setInputDisabled(true);
				history.goBack();
				break;		
			
			case 'Delete':
				if(params.id){
					if(parseInt(params.id) > 0){
						setAction(actions.delete);
						setInputDisabled(false);
						setInputMsg('Delete');
						setInputColor('Secondary')
						setSuccess('');
						setStatus(''); 
					}else{
						
						alert("No item to Delete.");
					}
				}else{
					
					alert("No item to Delete.");
				}	

				break;	

			case 'Back':
				setInputDisabled(true);
				setAction(null);
				history.goBack();
				break;
			default:
				console.log(e);
		}
		
		setAnchorEl(null);
	};


	const handleChange = (event) => {
		if(inputDisabled)return;

		setFormValues({ ...formValues, [event.target.name]: event.target.value });
		setFormErrors({
			...formErrors,
			...validateForm(event.target.name, event.target.value),
		});
	};
	
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	return (
	<Content>
		<div>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={handleClick}
			><MoreVertIcon />
			</IconButton>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
			><h5>Employee Details: {action} </h5>
			</IconButton>
			
			<Menu
				id="long-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
				PaperProps={{
				style: {
					maxHeight: ITEM_HEIGHT * 5,
					width: '20ch',
				},
				}}
			>
				{options.map((option) => (
				<MenuItem key={option}  onClick={(e)=>handleClose(e, option)}>
					
					<ListItemIcon>
						<ChevronRightTwoToneIcon fontSize="small"/>
					</ListItemIcon>
					<ListItemText primary={option} />	
					
				</MenuItem>
				))}
			</Menu>
		</div>
		<form className={classes.form} onSubmit={onSubmit}>
		
			<Blocker open={requesting} />
			{!closeModal && success && (<Redirect to={{ pathname: `${params.id}` }} />)}

			{success === false && <ErrorAlert>Failed: {status}</ErrorAlert>}
            {success === true && <SuccessAlert>Info: {status}</SuccessAlert>}  
            <WarningAlert>This form only shows full employee information. Changes to information
                will reflect if there are changes in HR People data during scheduled sync.
            </WarningAlert>

			<Grid
				container
				direction="column"
				justifyContent="flex-start"
				alignItems="center"
				spacing={3}
			>
				<Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Employee Name"
						variant="outlined"
						name="fullname"
						fullWidth
						value={formValues.fullname || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Employee ID"
						variant="outlined"
						name="empId"
						fullWidth
						value={formValues.empId || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="User Account"
						variant="outlined"
						name="userName"
						fullWidth
						value={formValues.userName || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Employment Status"
						variant="outlined"
						name="empStat"
						fullWidth
						value={formValues.empStat || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Job Title"
						variant="outlined"
						name="jobTitle"
						fullWidth
						value={formValues.jobTitle || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Job Level"
						variant="outlined"
						name="jobLevel"
						fullWidth
						value={formValues.jobLevel || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Business Unit"
						variant="outlined"
						name="company"
						fullWidth
						value={formValues.company || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Division"
						variant="outlined"
						name="division"
						fullWidth
						value={formValues.division || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Department"
						variant="outlined"
						name="department"
						fullWidth
						value={formValues.department || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Section"
						variant="outlined"
						name="section"
						fullWidth
						value={formValues.section || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Grid Location"
						variant="outlined"
						name="gridLoc"
						fullWidth
						value={formValues.gridLoc || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>
                <Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<TextField
						label="Grid"
						variant="outlined"
						name="grid"
						fullWidth
						value={formValues.grid || ''}
						/*onChange={handleChange}
						helperText={formErrors.fullname || ''}
						error={!!formErrors.fullname || false}
						required*/
					/>
				</Grid>


				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					{
						inputDisabled === false > 0 ?
							<Button
							type="submit"
							fullWidth
							variant="contained"
							color={inputColor}
							className={classes.submit}
							disabled={!isEmpty(formErrors)}
							>{inputMsg}
							</Button>	
							: null
					}
					
				</Grid>
				
			</Grid>
		</form>
	</Content>
	);
};

ToolsForm.propTypes = formPropTypes;

ToolsForm.defaultProps = formDefaultPropValues;

export default ToolsForm;
